<template>
  <div class="gj-table-parent_flex">
    <gj-table
        name="storageArgs"
        adaptParent
        :data="tableData"
        :columns="columns"
        :show-overflow="false"
        :loading="loading">
      <template v-slot:content="{ row }">
        <gj-select
            v-model="row.content"
            :options="argOptions(row.name)"
            :clearable="false"
            width="200px"
            @input="updateConfig($event, row)">
        </gj-select>
      </template>
    </gj-table>
  </div>
</template>

<script>
  import {queryMixin, responseMixin} from "../../../../../../minxins";
  import {getStatisticsArgs, updateStatisticsArgs} from "../../../../../../api/setting";
  import {isMeaningful} from "../../../../../../utils/common";
  import { storageAgeOption, dashboardPayOption, turnoverOption, rankOrderOption } from "./options.js"

  export default {
    name: "app-statistics-args",
    mixins: [queryMixin, responseMixin],
    data() {
      return {
        tableData: [],
        columns: [
          {id: 'name', header: '参数名称', field: 'option:name', minWidth: '200px', options: [
              {id: 'DASHBOARD_INVENTORY_AGE', text: '库龄设置'},
              {id: 'DASHBOARD_TURNOVER', text: '可售周转设置'},
              {id: 'DASHBOARD_PAY', text: '销售额计算规则设置'},
              {id: 'DASHBOARD_ORDER', text: '榜单排序字段设置'}
            ]},
          {id: 'content', header: '配置项', field: 'slot:content', minWidth: '200px'},
          {id: 'memo', header: '指标配置说明', field: 'memo', minWidth: '400px'},
          {id: 'updateTime', header: '更新时间', field: 'updateTime', width: '200px'},
        ]
      }
    },
    methods: {
      argOptions(type) {
        if (type === 'DASHBOARD_INVENTORY_AGE') {
          return storageAgeOption;
        } else if (type === 'DASHBOARD_TURNOVER') {
          return turnoverOption;
        } else if (type === 'DASHBOARD_ORDER') {
          return rankOrderOption;
        } else if (type === 'DASHBOARD_PAY') {
          return dashboardPayOption;
        } else {
          return [];
        }
      },
      updateConfig(content, row) {
        updateStatisticsArgs({
          name:row.name,
          id: row.id,
          content,
          memo: row.memo
        })
          .then((res) => {
            this.$gjResponseHandle(res, () => {
               this.$gjMessage.success('更新成功');
            });
          });
      },
      $gjQuery() {
        // 查询
        this.loading = true;
        getStatisticsArgs()
          .then((data) => {
            if (isMeaningful(data)) {
              this.tableData = data;
            } else {
              this.tableData = [];
            }
          })
          .complete(() => {
            this.loading = false;
          });
      },
    }
  }
</script>

<style scoped>
  /deep/ .gj-area-title {
    margin-bottom: 12px;
  }
</style>

